'use strict';

// Constructor
var SearchTerms = function () {
    // Change search box type
    $('.form-item-search input').attr('type', 'search');
    
    // Highlight the search terms
    var $term = $('.block-views-exposed-filter-blocksearch-search-page input').val();
    if ($term) {
        $(".layout-content").mark($term);
    }
    
    // Add the search term to the search box
    $('.path-search .form-item-search input').val($term);
};

module.exports = SearchTerms;
